import {Component, Injector} from '@angular/core';
import {DriversDialogBaseComponent} from "./drivers-dialog-base/drivers-dialog-base.component";

@Component({
    selector: 'app-edit-driver',
    templateUrl: './drivers-dialog-base/drivers-dialog-base.component.html',
    styleUrls: ['./drivers-dialog-base/drivers-dialog-base.component.css'],
    standalone: false
})
export class EditDriverComponent extends DriversDialogBaseComponent {

  constructor(protected injector:Injector) {
    super(injector);
    this.dialogId = "editDriver";
  }

  public submit() {

      this.service.updateDriver(this.model).subscribe((res) => {
          this.onCreated.emit();
          this.close();
          this.syncService.NotifyEntityChanged("Driver",this.model.Id);
          super.submit();

        });
  }

}
